/** The lengths the reading column is built from, shared by the parts that have to line up. */
export enum ChatMetric {
  COLUMN_PADDING = '16px',
  COMPOSER_INSET = '32px',
  LOG_GUTTER = '48px',
  PIN_OFFSET = '12dvh',
  SHELF_MAX_HEIGHT = '72px',
}
